import { Link, useLocation } from 'react-router-dom'
import { useData } from '../../contexts/DataContext'
import { useConfig } from '../../contexts/ConfigContext'

function Header() {
  const { config: dataConfig } = useData()
  const { getAppTitle, loading } = useConfig()
  const location = useLocation()

  const isActive = path => {
    if (path === '/dashboard') {
      return (
        location.pathname === '/dashboard' ||
        location.pathname.startsWith('/dashboard/')
      )
    }
    return location.pathname === path
  }

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-8">
            <Link
              to="/dashboard"
              className="flex align-middle text-2xl font-bold text-gray-900 hover:text-gray-700 transition-colors"
            >
              <img
                src="/img/logo.png"
                alt="App Logo"
                className="inline-block h-8 w-8 mr-2"
              />
              {getAppTitle()}
            </Link>

            {/* Navigation Links */}
            <nav className="hidden md:flex items-center space-x-6">
              <Link
                to="/dashboard"
                className={`px-3 py-2 rounded-lg font-medium transition-colors ${
                  isActive('/dashboard')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                📊 Dashboard
              </Link>
              <Link
                to="/datasets"
                className={`px-3 py-2 rounded-lg font-medium transition-colors ${
                  isActive('/datasets')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                📁 Datasets
              </Link>
            </nav>
          </div>

          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-500">
              {!loading && dataConfig ? 'Ready' : 'Loading...'}
            </span>
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className="md:hidden mt-4 flex space-x-4">
          <Link
            to="/dashboard"
            className={`px-3 py-2 rounded-lg font-medium transition-colors ${
              isActive('/dashboard')
                ? 'bg-primary-100 text-primary-700'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            }`}
          >
            📊 Dashboard
          </Link>
          <Link
            to="/datasets"
            className={`px-3 py-2 rounded-lg font-medium transition-colors ${
              isActive('/datasets')
                ? 'bg-primary-100 text-primary-700'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            }`}
          >
            📁 Datasets
          </Link>
        </nav>
      </div>
    </header>
  )
}

export default Header
